import normalize from "styled-normalize";
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-size: 10px;
    font-family: 'NanumSquareNeo', sans-serif;
    letter-spacing: -0.2px;
  }

  body {
  overscroll-behavior: none;
  }

  #root {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overscroll-behavior: none;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }
`;
